import { Form } from "@/components/Form";
import { MessageInput } from "@/features/misc/components";
import {
  messageInputSchema,
  MessageInputSchemaModel,
} from "@/features/misc/types/schema";
import { useAddEditCommentMutation } from "@/services/modules/postComment";
import { selectComment } from "@/store/postComment";
import { RootState } from "@/store/reducers";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

const AddComment = ({ postId }: { postId: number }) => {
  const [addEditComment] = useAddEditCommentMutation();
  const dispatch = useDispatch();
  const selectedComment = useSelector(
    (state: RootState) => state.postComment.selectedComment
  );
  const userList = useSelector((state: RootState) => state.post.userList);

  const handleCancel = () => {
    dispatch(selectComment(undefined));
  };

  function handleSave({ comment, files }: MessageInputSchemaModel) {
    addEditComment({
      comment,
      files,
      postId,
      parentId: selectedComment?.postCommentId,
    });
    handleCancel();
  }

  return (
    <Form<MessageInputSchemaModel, typeof messageInputSchema>
      onSubmit={async (values, event) => {
        handleSave(values);
        event?.target.reset();
      }}
      schema={messageInputSchema}
      options={{ defaultValues: { comment: "" } }}
    >
      {(props) => (
        <MessageInput
          model={props}
          placeholder="Comment"
          userList={userList}
          handleSend={handleSave}
        >
          {selectedComment && (
            <div className="flex flex-1 justify-between">
              <span className="text-sm ml-1 mb-1">
                Replying to {selectedComment.userName}
              </span>
              <div onClick={handleCancel}>
                <span className="text-sm ml-1">Cancel</span>
              </div>
            </div>
          )}
        </MessageInput>
      )}
    </Form>
  );
};

export default AddComment;
